export default "__VITE_ASSET__COXe9YBd__"